import { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Footer from '../../components/Footer/footer'
import {SET_TOKEN,SET_DOB,SET_ROLLNO,SET_TOAST_DATA, } from '../../constants/actionTypes'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import { getMonth, getYear } from 'date-fns'
import 'react-datepicker/dist/react-datepicker.css'
import LoginLhs from './LoginLhs'
import styles from './login.module.css'
import { SunspotLoader } from 'react-awesome-loaders'
import MaskedTextInput from 'react-text-mask'
import { InputField } from 'components/shared/InputField'
import { usePutPostApi } from 'api/usePutPostApi'
import config from 'config'
import { months, years } from 'components/Result/constants'
import LoginHeader from './LoginHeader'
import { formatDateSafe, getExamConfig, getExamType } from 'utils/common'

const mapStateToProps = (token) => {
    return token
}

const mapDispatchToProps = (dispatch) => ({
    setToken: (payload) => dispatch({ type: SET_TOKEN, payload }),
    setRollNo: (payload) => dispatch({ type: SET_ROLLNO, payload }),
    setDOB: (payload) => dispatch({ type: SET_DOB, payload }),
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
})

const Login = (props) => {
    const MAX_ROLLNO_LENGTH = 12
    const exam_Type = getExamType()
    const domainConfig = getExamConfig(exam_Type)
    let { registerPath } = domainConfig?.commonSettings || {}
    if (window.location.hostname.includes('aakashdigital.com')) {
        registerPath = "/adst"
    }

    // const datepickerRef = useRef()
    const [errorMsg, setErrorMsg] = useState({ rollno: '', dob: '' })
    const [rollno, setRollno] = useState('')
    const [dob, setDob] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    let history = useHistory()

    const { data, loading, setPutEnabled } = usePutPostApi(
        config.LOGIN_API,
        '',
        'post',
        { roll_number: rollno, date_of_birth: dob },
        false,
    )

    useEffect(() => {
        if (data && data.success === 'true') {
            props.setToken(data.token)
            props.setRollNo(rollno)

            const formattedDOB = formatDateSafe(dob) // Convert DOB to DD-MM-YYYY
            props.setDOB(dob)
            const dashboardUrl = new URL(data.dashboard_url);
            const currentUrl = new URL(window.location.href);
            const change = dashboardUrl.hostname.includes(currentUrl.hostname);
            if (data.dashboard_url && !change) { // Redirect user to relative domain
                dashboardUrl.searchParams.set('roll_no', rollno)
                dashboardUrl.searchParams.set('dob', formattedDOB)
                window.location.href = dashboardUrl.toString()
            } else {
                history.push('/dashboard') // Fallback to default route if no URL is provided
            }
        } else if (data && data.success === 'false') {
            props.setToastMsgsData({
                isToastOpen: true,
                toastType: 'danger',
                toastMessage: data?.msg || 'Something went wrong.',
            })
        }

        // eslint-disable-next-line
    }, [data])

    const handleRollNo = (event) => {
        const { value } = event.target

        setRollno(value.slice(0, MAX_ROLLNO_LENGTH))
        setErrorMsg({ ...errorMsg, rollno: '' })
    }

    const handleClick = () => {
        if ((rollno === '' || rollno.length !== MAX_ROLLNO_LENGTH) && dob === '')
            setErrorMsg({ rollno: 'Invalid roll number', dob: 'Invalid password' })
        else if (rollno === '' || rollno.length !== MAX_ROLLNO_LENGTH) {
            setErrorMsg({ ...errorMsg, rollno: 'Invalid roll number' })
        } else if (dob === '' || dob === null) {
            setErrorMsg({ ...errorMsg, dob: 'Invalid password' })
        }

        if (dob !== '' && dob !== null && rollno.length === MAX_ROLLNO_LENGTH)
            setPutEnabled(true)
    }

    return (
        <Fragment>
            {isLoading ? (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                    }}
                >
                    <SunspotLoader
                        gradientColors={['#4039d4', '#E0E7FF']}
                        size={'10px'}
                        desktopSize={'30px'}
                        mobileSize={'20px'}
                        className="m-auto"
                    />
                </div>
            ) : (
                <>
                    <LoginHeader />
                    <div className={styles.login}>
                        <LoginLhs />
                        <div className={styles.login2}>
                            <div
                                className={`${styles.card} bg-white d-flex flex-column align-items-center justify-content-center w-9 w-md-7 py-5 ps-2 pe-2 mt-3`}
                            >
                                <div className="w-9 w-md-9">
                                    <h1
                                        className={`${styles.loginheading} fw-lighter mb-4`}
                                    >
                                        Login to your dashboard
                                    </h1>

                                    <InputField
                                        value={rollno}
                                        onChange={handleRollNo}
                                        name="rollno"
                                        placeholder="Enter your roll number"
                                        title="Roll number"
                                        type="number"
                                        required
                                        errorMsg={errorMsg.rollno}
                                    />

                                    <label
                                        className={`form-control-label font-size-sm fw-lighter mt-lg-4 ${
                                            errorMsg.dob
                                                ? 'text-error-red'
                                                : 'text-light-grey-200'
                                        }`}
                                    >
                                        Password
                                    </label>
                                    <span>
                                        <DatePicker
                                            customInput={
                                                <MaskedTextInput
                                                    type="text"
                                                    mask={[
                                                        /\d/,
                                                        /\d/,
                                                        '/',
                                                        /\d/,
                                                        /\d/,
                                                        '/',
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]}
                                                />
                                            }
                                            className={`${
                                                styles.inputBox_login
                                            } w-100  px-2  ${
                                                errorMsg.dob
                                                    ? 'border border-error-red'
                                                    : 'border border-grey-100'
                                            }`}
                                            selected={dob}
                                            onChange={(date) => {
                                                setDob(date)
                                                setErrorMsg({
                                                    ...errorMsg,
                                                    dob: '',
                                                })
                                            }}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Enter Date of birth (DD/MM/YYYY)"
                                            renderCustomHeader={({
                                                date,
                                                changeYear,
                                                changeMonth,
                                            }) => (
                                                <div
                                                    className={styles.dateSelectDiv}
                                                >
                                                    <select
                                                        value={
                                                            months[getMonth(date)]
                                                        }
                                                        onChange={({
                                                            target: { value },
                                                        }) =>
                                                            changeMonth(
                                                                months.indexOf(
                                                                    value,
                                                                ),
                                                            )
                                                        }
                                                    >
                                                        {months.map((option) => (
                                                            <option
                                                                key={option}
                                                                value={option}
                                                            >
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <select
                                                        value={getYear(date)}
                                                        onChange={({
                                                            target: { value },
                                                        }) => changeYear(value)}
                                                    >
                                                        {years.map((option) => (
                                                            <option
                                                                key={option}
                                                                value={option}
                                                            >
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                        />
                                    </span>
                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                        {errorMsg.dob && (
                                            <p className="font-size-xs text-error-red mt-1">
                                                {errorMsg.dob}
                                            </p>
                                        )}
                                        <p
                                            className="text-aqua font-size-xs cursor-pointer text-end mt-1 ms-auto"
                                            onClick={() => {
                                                window.webengage.track(
                                                    exam_Type == 'IAT' || exam_Type=="MOCK-JEE"
                                                        ? exam_Type +
                                                              '_forget_roll_no_password_click'
                                                        : 'iACST_login_forgot_pw',
                                                    {
                                                        'page url':
                                                            window.location.href,
                                                        'utm parameters':
                                                            localStorage.getItem(
                                                                'utmParams',
                                                            ),
                                                    },
                                                )
                                                history.push('/recover-credentials')
                                            }}
                                        >
                                            Forgot roll number/password?
                                        </p>
                                    </div>

                                    <button
                                        className={`btn btn-sky-blue-09 text-white w-100 fw-lighter font-size-sm rounded-10px mt-3 mb-2 ${styles.submitButton}`}
                                        onClick={handleClick}
                                        // isLoading={isLoading}
                                    >
                                        Login
                                    </button>

                                    <p
                                        className={`${styles.dontacct} font-size-lg-md font-size-xs text-center mt-2`}
                                    >
                                        Don’t have an account?
                                        <span
                                            className="text-aqua cursor-pointer font-size-lg-lg font-size-sm"
                                            onClick={() => {
                                                window.webengage.track(
                                                    exam_Type+'_login_register',
                                                    {
                                                        'utm parameters':
                                                            localStorage.getItem(
                                                                'utmParams',
                                                            ),
                                                    },
                                                )

                                                if (registerPath) {
                                                    window.location.href = registerPath
                                                } else {
                                                    window.location.href = '/iacstexam'
                                                }
                                            }}
                                        >
                                            &nbsp;Register here
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </Fragment>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)
